// Typed Hono RPC client for apps/api, built from that app's own route types
// (apps/api/src/core/app.ts `AppType`), so every call is checked against the
// real request and response shapes at build time instead of being hand-typed.
//
// The `AppType` import is `import type` only, so Bun's transpiler elides it:
// apps/api runtime code never ships to the browser.
//
// `credentials: "include"` sends the httpOnly `procureai_session` cookie to
// the API origin (a different port in development, so the request is
// cross-origin and needs it explicitly).
import { hc } from "hono/client";
import type { AppType } from "@procureai/api/src/core/app";

// The API origin. build.ts inlines process.env.API_URL through Bun.build
// define (default http://localhost:3001), so the browser bundle carries the
// literal and never reads `process` at runtime; under bun test the real
// environment variable, or the same default, applies. server.ts builds the
// CSP connect-src from the same variable, so the two cannot drift apart.
const apiUrl = process.env.API_URL || "http://localhost:3001";

type FetchLike = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

// The transport can be swapped once at boot. Only the dev fixture mode does
// that (src/dev/fixtures.ts, compiled out of production builds); everything
// else always goes to the network.
let transport: FetchLike | null = null;

export function setTransport(next: FetchLike | null): void {
  transport = next;
}

const send: FetchLike = (input, init) => (transport ?? globalThis.fetch)(input, init);

export const api = hc<AppType>(apiUrl, {
  fetch: send as typeof fetch,
  init: { credentials: "include" },
});

export const API_URL = apiUrl;
